import app from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyBKW00mjBkhxPg6ACv8n0F2tKPkSlR6mpM",
    authDomain: "usku-delivery.firebaseapp.com",
    databaseURL: "https://usku-delivery.firebaseio.com",
    projectId: "usku-delivery",
    storageBucket: "usku-delivery.appspot.com",
    messagingSenderId: "578333062077",
    appId: "1:578333062077:web:86d6a325037c08f96718d4",
    measurementId: "G-M5Y9E5BVCJ"
};

app.initializeApp(firebaseConfig);

export const realtimeDB = app.database();
export const db = app.firestore();
export const auth = app.auth();
export const storage = app.storage();